export const page_status = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]


// WEBPACK FOOTER //
// ./src/components/pages/mocks.js